/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Auth } from 'app/scripts/db/Auth';
import { ConfirmationPublicBoardsView } from 'app/scripts/views/board/ConfirmationPublicBoardsView';
import { BoardSelectOrganizationForPermChangeView } from 'app/scripts/views/board-menu/BoardSelectOrganizationForPermChangeView';
import { View } from 'app/scripts/views/internal/view';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { BoardMenuVisTemplate } from 'app/scripts/views/templates/BoardMenuVisTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface ChangeBoardVisibilityView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenTo: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modelCache: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class ChangeBoardVisibilityView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'tagName' does not exist on type 'ChangeB... Remove this comment to see the full error message
    this.prototype.tagName = 'ul';

    // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Chang... Remove this comment to see the full error message
    this.prototype.className = 'pop-over-list';

    // @ts-expect-error TS(2339): Property 'maxWidth' does not exist on type 'Change... Remove this comment to see the full error message
    this.prototype.maxWidth = 370;

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'ChangeBo... Remove this comment to see the full error message
    this.prototype.events = { 'click .js-select': 'selectVis' };
  }
  viewTitleKey() {
    if (this.model.owned()) {
      return 'change visibility';
    } else {
      return 'visibility';
    }
  }

  initialize() {
    this.listenTo(this.model, 'change', this.render);
  }

  render() {
    const org = this.model.getOrganization();
    const enterprise = org != null ? org.getEnterprise() : undefined;

    const isPremiumBoard = this.model.isPremiumBoard();
    const isEnterprise = this.model.isFeatureEnabled('enterpriseUI');
    const isEnterpriseAdmin = isEnterprise
      ? enterprise?.isAdmin(Auth.me())
      : false;
    // if they're an enterprise admin, they have admin privileges even if they're a guest on the board, so
    // don't block them without checking canSetVisibility
    // if they're a guest on a premium account otherwise, they don't get visibility changing abilities
    const isGuestOnPremium = isEnterpriseAdmin
      ? false
      : isPremiumBoard && this.model.isGuest(Auth.me());

    this.$el.html(
      BoardMenuVisTemplate({
        canChange: this.model.owned(),
        current: this.model.getPref('permissionLevel'),
        hasSuperAdmins: org?.hasPremiumFeature('superAdmins') || false,
        hasOrg: org != null,
        orgName: org != null ? org.get('displayName') : undefined,
        privateRestricted:
          isGuestOnPremium || !this.model.canSetVisibility('private'),
        orgRestricted:
          isGuestOnPremium ||
          (org != null &&
            !(org != null ? org.canSetVisibility('org') : undefined)),
        enterpriseRestricted:
          isGuestOnPremium ||
          (org != null &&
            !(org != null ? org.canSetVisibility('enterprise') : undefined)),
        publicRestricted:
          isGuestOnPremium || !this.model.canSetVisibility('public'),
        hasEnterprise: org != null ? isEnterprise : undefined,
        enterpriseName:
          enterprise != null ? enterprise.get('displayName') : undefined,
        isTemplate: this.model.isTemplate(),
        isPaidOrg: org?.hasPaidProduct(),
      }),
    );

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectVis(e: any) {
    stopPropagationAndPreventDefault(e);

    // eslint-disable-next-line @trello/enforce-variable-case
    const $target = $(e.target).closest('.js-select');

    if (
      $target.hasClass('disabled') ||
      $target.closest('.js-disabled').length
    ) {
      return;
    }

    const setting = $target.attr('name');
    if (setting === 'public') {
      PopOver.pushView({
        elem: e.target,
        // @ts-expect-error TS(2351): This expression is not constructable.
        view: new ConfirmationPublicBoardsView({
          model: this.model,
          modelCache: this.modelCache,
        }),
        maxWidth: 370,
      });

      return;
    }

    if (setting === 'org' && !this.model.getOrganization()) {
      // show org picker
      PopOver.pushView({
        view: BoardSelectOrganizationForPermChangeView,
        options: {
          model: this.model,
          modelCache: this.modelCache,
          disableNone: true,
        },
      });
      return;
    }

    const traceId = Analytics.startTask({
      taskName: 'edit-board/prefs/permissionLevel',
      source: 'changeBoardVisibilityInlineDialog',
    });

    const previous = this.model.getPref('permissionLevel');

    this.model.setPrefWithTracing('permissionLevel', setting, {
      taskName: 'edit-board/prefs/permissionLevel',
      source: 'changeBoardVisibilityInlineDialog',
      traceId,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      next: (_err: any, res: any) => {
        if (res) {
          Analytics.sendUpdatedBoardFieldEvent({
            field: 'visibility',
            value: setting,
            source: 'changeBoardVisibilityInlineDialog',
            containers: {
              board: {
                id: this.model.id,
              },
              organization: {
                id: this.model.getOrganization()?.id,
              },
            },
            attributes: {
              change: previous !== setting,
              previous,
              taskId: traceId,
            },
          });
        }
      },
    });
    this.model.save();

    PopOver.popView();
  }
}

ChangeBoardVisibilityView.initClass();
export { ChangeBoardVisibilityView };
